export enum Entities {
  Nucleotide = 'Nucleotide',
  Nucleoside = 'Nucleoside',
  Phosphate = 'Phosphate',
}
